<template>
	<div>
		<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
			<freeUserTips :type="4" :bgtype="0"></freeUserTips>
		</el-dialog>

		<!-- 搜索框区域（始终显示） -->
		<dl class="opport-screen bdbe opport-screen-overflow-auto" v-if="isShowNotionScreen">
			<dt class="fl">搜索产业</dt>
			<dd class="fl screenop">
				<div class="sider-left por">
					<div class="area-bar" style="height: 32px;">
						<div class="search-bar">
							<el-input class="search-text" ref="elSearch" clearable prefix-icon="el-icon-search"
								placeholder="请输入产业关键词" v-model="searchWord" @focus="onSearchFocus"></el-input>
						</div>
					</div>
					<div class="view-bar box-shadow" v-show="showSearchResult">
						<div class="box-card search-result">
							<div class="cont cont2">
								<div class="item" @click="onSelectItem(item)" v-for="(item, index) in searchList"
									:key="index">
									<p class="title" v-html="formatSearchTitle(item.label)"></p>
									<p class="addr" v-if="item.searchPath">{{ item.searchPath }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</dd>
		</dl>

		<!-- 层级选择区域（搜索点击后才显示） -->
		<template v-if="!isSearchMode">
			<dl class="opport-screen bdbe opport-screen-overflow-auto" v-show="showFirstList">
				<dt class="fl">{{ oneLevelTitle }}</dt>
				<dd class="fl screenop">
					<span @click="beforeChooseNotion(1, 'a', { label: '全部', value: 0, children: [] })"
						:class="chooseNotionlist[0] === 0 ? 'a-screen current' : 'a-screen'"
						v-show="isShowOneLevelTotal || isShowOneLevelTotalTag">全部</span>
					<span :key="index" v-for="(item, index) in notionlist" :class="{
						'a-screen': true, 'current': chooseNotionlist[0] === item.value,
						'before-line ml-4': !isStickySimpleNoting && item.value === 'U',
						'after-line mr-4': isStickySimpleNoting && item.value === 'U',
					}" @click="beforeChooseNotion(1, 'a', item)">{{ item.label }}</span>
				</dd>
			</dl>
			<dl class="opport-screen bdbe" v-show="notionlist1.length > 0 && showLevelNum > 1"
				:class="{ 'opport-screen-overflow-auto': !showFirstList }">
				<dt class="fl titleop">一级产业</dt>
				<dd class="fl">
					<span @click="beforeChooseNotion(2, 'all', fenkd)"
						v-show="computedNotionNum && isShowSecondLevelTotal"
						:class="chooseNotionlist[1] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
					<span :key="index" v-for="(item, index) in notionlist1"
						:class="chooseNotionlist[1] == item.value ? 'a-screen current' : 'a-screen'"
						@click="beforeChooseNotion(2, 'a', item)">{{ item.label }}<em class="num"
							v-show="!searchNotionBtn && item.num && item.num > 0">({{ item.num }})</em></span>
				</dd>
			</dl>
			<dl class="opport-screen bdbe" v-if="notionlist2.length > 0 && showLevelNum > 2">
				<dt class="fl titleop">二级细分</dt>
				<dd class="fl">
					<span @click="beforeChooseNotion(3, 'all', fenkd)" v-show="computedNotionNum"
						:class="chooseNotionlist[2] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
					<span :key="index" v-for="(item, index) in notionlist2"
						:class="chooseNotionlist[2] == item.value ? 'a-screen current' : 'a-screen'"
						@click="beforeChooseNotion(3, 'a', item)">{{ item.label }}<em class="num"
							v-show="!searchNotionBtn && item.num && item.num > 0">({{ item.num }})</em></span>
				</dd>
			</dl>
			<dl class="opport-screen bdbe" v-show="notionlist3 && notionlist3.length > 0 && showLevelNum > 3">
				<dt class="fl titleop">三级细分</dt>
				<dd class="fl">
					<span @click="beforeChooseNotion(4, 'all', fenkd)"
						:class="chooseNotionlist[3] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
					<span :key="index" v-for="(item, index) in notionlist3"
						:class="chooseNotionlist[3] == item.value ? 'a-screen current' : 'a-screen'"
						@click="beforeChooseNotion(4, 'a', item)">{{ item.label }}<em class="num"
							v-show="!searchNotionBtn && item.num && item.num > 0">({{ item.num }})</em></span>
				</dd>
			</dl>
			<dl class="opport-screen bdbe" v-show="notionlist4.length > 0 && showLevelNum > 4">
				<dt class="fl titleop">四级细分</dt>
				<dd class="fl">
					<span @click="beforeChooseNotion(5, 'all', fenkd)"
						:class="chooseNotionlist[4] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
					<span :key="index" v-for="(item, index) in notionlist4"
						:class="chooseNotionlist[4] == item.value ? 'a-screen current' : 'a-screen'"
						@click="beforeChooseNotion(5, 'a', item)">{{ item.label }}</span>
				</dd>
			</dl>
		</template>
	</div>
</template>

<script>
export default {
	name: 'zpagenav',
	data() {
		return {
			userdata: {},
			title: "概念的展示与搜索",
			notiontext: '',
			notionCode: '0',
			chooseNotionlist: [0, 0, 0, 0, 0],
			chooseNotionTextlist: ['', '', '', '', '', ''],
			notionlistDefault: [],
			notionStep: 1,
			notionlist: [],
			notionlist1: [],
			notionlist2: [],
			notionlist3: [],
			notionlist4: [],
			notionlist5: [],
			notionlist6: [],
			fenkd: { children: [] },
			searchWord: '',
			showSearch: true,
			showSearchResult: false,
			searchList: [],
			searchTimerId: 0,
			viewList: [],
			searchNotionBtn: false,
			computedNotionNum: true,
			notionExted: [0, 0, 0, 0, 0],
			matchedItems: {},
			isShowSecondLevelTotal: true,
			tempLinkCode: '',
			isShowFreeUserTips: false,
			searchFlatList: [],
			isSearchMode: true,
		}
	},
	watch: {
		searchWord() {
			this.searchEnterprise();
		},
		notionNumberList: {
			handler(newValue, oldValue) {
				console.log('notionNumberList', newValue);
				if (this.ucomputer) {
					return;
				}
				this.notionNumberList = newValue;
				this.setnotionNumlist(this.notionNumberList);
			}
		},
		notionlistDefault: {
			handler(newValue, oldValue) {
			}
		},
		showNotionCodeList: {
			handler(newValue, oldValue) {
				this.showNotionCodeList = newValue;
			}
		},
		isIntegration: {
			handler(newval) {
				console.log('isIntegration', newval);
				this.notionlist = this.setIsIntegration(this.notionlist);
			}
		},
		refreshNum: {
			handler(newval, oldval) {
				this.refreshNum = newval;
				setTimeout(() => {
					if (this.showNotionCodeList && !(Object.keys(this.showNotionCodeList).length === 0)) {
						this.filterNotionList(this.notionlistDefault, this.showNotionCodeList).then((res) => {
							this.notionlist = res;
							this.notionlist1 = this.notionlist[0].children;
							if (this.isClearNotion) {
								this.clearNotionResult();
							}
						});
					}
				}, 300)
				if (this.isClearNotion) {
					this.clearNotionResult();
				}
			}
		},
	},
	props: {
		type: { type: Number, default: 1 },
		notionNumberList: { type: Array },
		refreshNum: { type: Number, default: 1 },
		isShowNotionScreen: { type: Boolean, default: false },
		token: { type: String, default: "" },
		isClearNotion: { type: Boolean, default: false },
		oneLevelTitle: { type: String, default: '产业分类' },
		isShowOneLevelTotal: { type: Boolean, default: true },
		isShowOneLevelTotalTag: { type: Boolean, default: true },
		showLevelNum: { type: Number, default: 5 },
		isShowManufacturing: { type: Boolean, default: false },
		showNotionExtend: { type: Boolean, default: false },
		showNotionCodeList: {},
		isIntegration: { type: Boolean, default: false },
		isShowFutureIndustries: { type: Boolean, default: false },
		linkNotionCode: { type: String, default: '' },
		ucomputer: { type: Boolean, default: false },
		showSimpleNotion: { type: Boolean, default: false },
		defaultSelected: { type: String, default: '' },
		showFirstList: { type: Boolean, default: true },
		isStickySimpleNoting: { type: Boolean, default: false },
	},
	created() {
		this.userdata = this.getuseriformation();
		this.ajaxGetNotionList();
	},
	mounted() {
	},
	methods: {
		// 新增：搜索框获得焦点时，如果还没展开过，保持搜索模式
		onSearchFocus() {
			// 可选：点击搜索框时自动清空之前的层级选择
			// this.clearNotionResult();
		},
		setIsIntegration(notionArray) {
			console.log('整合产业', notionArray);
			let tempData = { label: '传统产业', value: 'DEF', parentList: ['DEF'], children: [] };
			let newTree = [];
			if (this.isIntegration) {
				notionArray.forEach((item, i) => {
					if (item.label == '第一产业' || item.label == '第二产业' || item.label == '第三产业') {
						tempData.children.push(item);
						newTree[0] = tempData;
					}
					if (item.label == '先进制造业') {
						item.label = '战略性新兴产业';
						newTree[1] = item;
					}
					if (item.label == '未来产业') {
						newTree[2] = item;
					}
				});
			}
			console.log('整合产业111', newTree);
			return newTree;
		},

		filterNotionList(notionArray, dict) {
			return new Promise((resolve, reject) => {
				if (Object.keys(dict).length == 0) {
					notionArray = notionArray.filter(item => {
						return item.label != '未来产业';
					});
					resolve(notionArray);
				}
				const newTree = [];

				function traverse(node) {
					if (node.value in dict) {
						const newNode = { ...node };
						if (node.children) {
							newNode.children = node.children.filter(child => traverse(child));
						}
						return newNode;
					}
					if (node.children) {
						const filteredChildren = node.children.filter(child => traverse(child));
					}
					return false;
				}

				notionArray.forEach(rootNode => {
					const newNode = traverse(rootNode);
					if (newNode) {
						newTree.push(newNode);
					}
				});
				console.log('筛选后的结果', newTree);
				resolve(newTree);
			});
		},

		beforeChooseNotion(step, type, data, index) {
			if (!this.userdata.token) {
				this.isShowFreeUserTips = true;
				return;
			}
			console.log('beforeChooseNotion', step, type, data, index);
			if (this.showNotionCodeList && !(Object.keys(this.showNotionCodeList).length === 0)) {
				this.filterNotionList(this.notionlistDefault, this.showNotionCodeList).then((res) => {
					this.chooseNotion(step, type, data, index);
				});
			} else {
				this.chooseNotion(step, type, data, index);
			}
		},

		getSimpleNotionList() {
			var _this = this;
			this.$axios.get(this.$api.cyl.usercenter.investNotion(), {
				headers: { AuthToken: this.token }
			}).then(function (res) {
				if (res.data.success) {
					let temNotionList = res.data.list;
					let testNostion = {};
					testNostion.children = temNotionList;
					testNostion.level = 0;
					testNostion.label = '重点产业';
					testNostion.value = 'U';
					testNostion.parentList = ['U'];
					testNostion.relatedCode = '';
					testNostion = _this.transformData(testNostion);
					let firstChild = testNostion.children;
					for (let i = 0; i < firstChild.length; i++) {
						firstChild[i].value = 'U' + firstChild[i].name;
					}
					if (_this.showFirstList) {
						_this.isStickySimpleNoting ? _this.notionlist.unshift(testNostion) : _this.notionlist.push(testNostion);
					} else {
						_this.notionlist = [testNostion];
					}
					if (_this.defaultSelected == 'simpleNotion') {
						console.log('默认简易版重点产业beforeChooseNotion', testNostion);
						_this.beforeChooseNotion(1, 'a', testNostion, 0);
					}
					_this.notionlistDefault.push(testNostion);
					console.log('简易版重点产业notionlist', _this.notionlist);
				}
			}).catch(function (error) {
			});
		},

		transformData(obj) {
			if (Array.isArray(obj)) {
				return obj.map(item => this.transformData(item));
			} else if (typeof obj === 'object' && obj !== null) {
				if ('name' in obj) {
					obj.label = obj.name;
				}
				if ('code' in obj) {
					obj.value = obj.code;
					obj.relatedCode = obj.code;
					obj.iskeyNotion = true;
				}
				for (let key in obj) {
					if (typeof obj[key] === 'object' && obj[key] !== null) {
						obj[key] = this.transformData(obj[key]);
					}
				}
				return obj;
			}
			return obj;
		},

		getNotionExtend() {
			var _this = this;
			this.$axios.get(this.$api.tag.notionExtend.list(), {
				headers: { AuthToken: this.token }
			}).then(function (res) {
				console.log('重点产业', res);
				if (res.data.success) {
					let notionExtendList = res.data.list;
					console.log('notionExtendList', notionExtendList);
					notionExtendList.forEach((list) => {
						list.parentList = [list.value];
						_this.notionlist.push(list);
						_this.notionlistDefault.push(list);
					})
				}
			}).catch(function (error) {
			});
		},

		ajaxGetNotionList() {
			var _this = this;
			this.$axios.get(this.$api.tag.notion.list() + '?level=6', {
				headers: { AuthToken: this.token }
			}).then(function (res) {
				console.log('三大产业概念数据', res);
				if (res.data.success) {
					_this.notionlist = res.data.list;
					_this.notionlistDefault = res.data.list;

					for (var i = 0; i < _this.notionlist.length; i++) {
						_this.notionlist[i].parentList = [_this.notionlist[i].value];
						if (_this.notionlist[i].value == 'A') {
							_this.notionlist[i].children = _this.notionlist[i].children.filter(lists => {
								return lists.label != '环保';
							})
						}
					}
					if (_this.linkNotionCode != '' && _this.linkNotionCode) {
						console.log('linkNotionCode', _this.linkNotionCode)
						_this.filterTree(_this.linkNotionCode, _this.notionlistDefault, 2).then((res) => {
							console.log('筛选后的结果', res, _this.linkNotionCode);
							_this.onSelectItem(_this.tempLinkCode);
						})
					}
					if (!_this.isShowFutureIndustries) {
						_this.notionlist = _this.notionlist.filter((list => {
							return list.label.indexOf('未来') < 0;
						}))
					}

					if (_this.isShowManufacturing) {
						_this.notionlist = _this.notionlist.filter((list => {
							return list.label == '先进制造业';
						}))
					}
					if (_this.isIntegration) {
						_this.notionlist = _this.setIsIntegration(_this.notionlist);
					}
					_this.chooseNotionlist = _this.isShowOneLevelTotal ? [0, 0, 0, 0, 0] : ['A', 0, 0, 0, 0, 0];
					_this.notionCode = _this.isShowOneLevelTotal ? 0 : 'A';

					if (_this.showNotionCodeList && !(Object.keys(_this.showNotionCodeList).length === 0)) {
						_this.filterNotionList(_this.notionlistDefault, _this.showNotionCodeList).then((res) => {
						});
					}
					_this.notionlist1 = _this.isShowOneLevelTotal ? [] : _this.notionlist[0].children;
					console.log('this.notionlist', _this.notionlist, _this.notionlist1);
					if (_this.showNotionExtend) {
						_this.getNotionExtend();
					}
					if (_this.showSimpleNotion) {
						_this.getSimpleNotionList();
					}

					// 数据加载完成后，构建搜索用的扁平化数据
					_this.buildSearchFlatList();
				}
			}).catch(function (error) {
			});
		},

		// ========== 新增：构建从二级细分开始的扁平化搜索数据 ==========
		buildSearchFlatList() {
			this.searchFlatList = [];
			const sourceList = this.isIntegration ? this.notionlist : this.notionlistDefault;

			sourceList.forEach(topItem => {
				if (topItem.children && topItem.children.length > 0) {
					topItem.children.forEach(secondItem => {
						// 从二级节点开始递归，构建完整路径
						// parentPath 初始只包含产业分类
						this.flattenTree(secondItem, [topItem.value], topItem.label + ' > ' + secondItem.label);
					});
				}
			});
			console.log('搜索扁平化数据构建完成', this.searchFlatList.length);
		},

		// ========== 新增：递归扁平化树，记录完整路径 ==========
		flattenTree(node, parentPath, searchPath) {
			// parentPath 是从产业分类开始的完整路径 [产业分类value, 一级value, 二级value...]
			const flatNode = {
				...node,
				searchPath: searchPath,
				parentPath: [...parentPath]  // 完整父级value链（不包含当前节点）
			};
			this.searchFlatList.push(flatNode);

			if (node.children && node.children.length > 0) {
				node.children.forEach(child => {
					// 当前节点加入 parentPath，传给子节点
					this.flattenTree(child, [...parentPath, node.value], searchPath + ' > ' + child.label);
				});
			}
		},

		// ========== 重写：概念搜索（从二级细分开始） ==========
		searchEnterprise(kw) {
			this.showSearchResult = this.searchWord != '';
			console.log('搜索的词', this.searchWord, '扁平数据长度:', this.searchFlatList.length);

			if (this.showSearchResult) {
				this.searchList = [];
				const keyword = this.searchWord.trim();

				if (keyword && this.searchFlatList.length > 0) {
					// 过滤：label 包含关键词，且层级 >= 3（二级细分及以上）
					this.searchList = this.searchFlatList.filter(item => {
						const level = item.parentPath ? item.parentPath.length + 1 : 1;
						// level >= 3 表示：产业分类(1) -> 一级产业(2) -> 二级细分(3)
						const shouldInclude = level >= 3 && item.label.indexOf(keyword) > -1;
						if (shouldInclude) {
							// console.log('搜索命中:', item.label, '层级:', level, '路径:', item.searchPath);
						}
						return shouldInclude;
					});

					this.searchList = this.sortCodeLength(this.searchList);
				}

				console.log('搜索结果数量:', this.searchList.length);
			}
		},
		sortCodeLength(list) {
			return list.sort((a, b) => {
				return b.value.length - a.value.length;
			});
		},
		// ========== 重写：选中搜索后的概念 ==========
		// 重写：选中搜索后的概念
		onSelectItem(data) {
			console.log('选中搜索后的概念', data);

			// 退出搜索模式，显示层级
			this.isSearchMode = false;

			if (data.value && data.value.indexOf('U') > -1) {
				this.notionCode = data.relatedCode;
			} else {
				this.notionCode = data.value;
			}
			this.notiontext = data.label;
			this.searchNotionBtn = true;

			let parentPath = data.parentPath || [];
			console.log('parentPath', parentPath, '当前节点value', data.value);

			let fullList = [0, 0, 0, 0, 0];
			for (let i = 0; i < parentPath.length && i < 5; i++) {
				fullList[i] = parentPath[i];
			}
			let currentIndex = parentPath.length;
			if (currentIndex < 5) {
				fullList[currentIndex] = data.value;
			}
			this.chooseNotionlist = fullList;
			console.log('构建的 chooseNotionlist', this.chooseNotionlist);

			if (!this.notionlist || this.notionlist.length === 0) {
				console.error('notionlist 为空，无法展开');
				return;
			}

			// 同步方式逐层展开
			if (parentPath.length > 0) {
				this.slideNotionList(1, parentPath[0]);
			}
			if (parentPath.length > 1) {
				this.slideNotionList(2, parentPath[1]);
			}
			if (parentPath.length > 2) {
				this.slideNotionList(3, parentPath[2]);
			}
			if (parentPath.length > 3) {
				this.slideNotionList(4, parentPath[3]);
			}
			this.slideNotionList(parentPath.length + 1, data.value);

			this.closeSearchBar();
			this.$emit('chooseNotion', this.chooseNotionlist, this.notionCode, null, this.notiontext);
		},
		// 新增：重置为搜索模式（可在外部调用）
		resetToSearchMode() {
			this.isSearchMode = true;
			this.clearNotionResult();
			this.searchWord = '';
			this.showSearchResult = false;
			this.searchList = [];
		},
		// ========== 重写：筛选概念后逐层打开 ==========
		slideNotionList(step, parentcode) {
			console.log('=== 打开层级 ===', 'step:', step, 'parentcode:', parentcode);

			if (!parentcode && parentcode !== 0) {
				console.warn('parentcode 为空，跳过层级', step);
				return;
			}

			if (step == 1) {
				console.log('Step1: 在 notionlist 中查找', parentcode, 'notionlist长度:', this.notionlist.length);
				var list2 = this.notionlist.filter(list => {
					return list.value == parentcode;
				});
				console.log('Step1: 找到', list2.length, '个匹配');

				if (list2.length > 0 && list2[0].children) {
					this.notionlist1 = list2[0].children.filter(list => {
						return list.label != '环保';
					});
					console.log('Step1: notionlist1 设置完成', this.notionlist1.length);
				} else {
					console.warn('Step1: 未找到一级节点或没有children:', parentcode);
					this.notionlist1 = [];
				}
				this.notionlist2 = [];
				this.notionlist3 = [];
				this.notionlist4 = [];
				this.notionlist5 = [];

			} else if (step == 2) {
				console.log('Step2: 在 notionlist1 中查找', parentcode, 'notionlist1长度:', this.notionlist1 ? this.notionlist1.length : 0);
				if (!this.notionlist1 || this.notionlist1.length === 0) {
					console.warn('Step2: notionlist1 为空，无法展开二级');
					return;
				}
				var list2 = this.notionlist1.filter(list => {
					return list.value == parentcode;
				});
				console.log('Step2: 找到', list2.length, '个匹配');

				if (list2.length > 0 && list2[0].children) {
					this.notionlist2 = list2[0].children;
					console.log('Step2: notionlist2 设置完成', this.notionlist2.length);
				} else {
					console.warn('Step2: 未找到二级节点或没有children:', parentcode);
					this.notionlist2 = [];
				}
				this.notionlist3 = [];
				this.notionlist4 = [];
				this.notionlist5 = [];

			} else if (step == 3) {
				console.log('Step3: 在 notionlist2 中查找', parentcode, 'notionlist2长度:', this.notionlist2 ? this.notionlist2.length : 0);
				if (!this.notionlist2 || this.notionlist2.length === 0) {
					console.warn('Step3: notionlist2 为空，无法展开三级');
					return;
				}
				var list2 = this.notionlist2.filter(list => {
					return list.value == parentcode;
				});
				if (list2.length > 0 && list2[0].children) {
					this.notionlist3 = list2[0].children;
				} else {
					this.notionlist3 = [];
				}
				this.notionlist4 = [];
				this.notionlist5 = [];

			} else if (step == 4) {
				if (!this.notionlist3 || this.notionlist3.length === 0) {
					console.warn('Step4: notionlist3 为空');
					return;
				}
				var list2 = this.notionlist3.filter(list => {
					return list.value == parentcode;
				});
				if (list2.length > 0 && list2[0].children) {
					this.notionlist4 = list2[0].children;
				} else {
					this.notionlist4 = [];
				}
				this.notionlist5 = [];

			} else if (step == 5) {
				if (!this.notionlist4 || this.notionlist4.length === 0) {
					console.warn('Step5: notionlist4 为空');
					return;
				}
				var list2 = this.notionlist4.filter(list => {
					return list.value == parentcode;
				});
				if (list2.length > 0 && list2[0].children) {
					this.notionlist5 = list2[0].children;
				}
			}

			console.log('=== 层级展开后状态 ===', {
				notionlist1: this.notionlist1 ? this.notionlist1.length : 0,
				notionlist2: this.notionlist2 ? this.notionlist2.length : 0,
				notionlist3: this.notionlist3 ? this.notionlist3.length : 0,
				notionlist4: this.notionlist4 ? this.notionlist4.length : 0,
			});
		},

		chooseNotion(step, type, data, index) {
			console.log('概念单选', step, type, data, this.chooseNotionlist);

			if (data.value && ((data.value.indexOf('U') > -1) || data.iskeyNotion)) {
				this.computedNotionNum = false;
				this.fenkd = { value: 'U', children: [] };
			} else {
				this.computedNotionNum = true;
				this.fenkd = { children: [] };
			}

			var siblingsList = [];
			this.notionStep = step;
			this.searchNotionBtn = false;

			if (type == 'all') {
				if (this.computedNotionNum) {
					this.notionCode = this.chooseNotionlist[step - 2];
				} else {
					this.notionCode = this.notionExted[step - 2];
				}
				this.notiontext = this.chooseNotionTextlist[step - 2];
				this.chooseNotionlist[step - 1] = '0';
				this.notionExted[step - 1] = 0;
				this.chooseNotionTextlist[step - 1] = '';
			} else {
				this.chooseNotionlist[step - 1] = data.value;
				this.chooseNotionTextlist[step - 1] = data.label;
				for (var i = 0; i < this.chooseNotionlist.length; i++) {
					if (i > step - 1) {
						this.chooseNotionlist[i] = '0';
						this.chooseNotionTextlist[i] = '';
					}
				}
				if (this.computedNotionNum) {
					this.notionCode = data.value;
					if (this.isIntegration && step == 1 && data.value == 'DEF') {
						this.notionCode = data.children[0].value;
						this.chooseNotionlist[step] = data.children[0].value;
						this.chooseNotionTextlist[step] = data.children[0].label;
						this.notionlist2 = data.children[0].children;
						this.isShowSecondLevelTotal = false;
					} else {
						if (data.value && data.value.indexOf('D') < 0 && data.value.indexOf('E') < 0 && data.value.indexOf('F') < 0) {
							this.isShowSecondLevelTotal = true;
						}
					}
				} else {
					this.notionExted[step - 1] = data.relatedCode;
					this.notionCode = data.relatedCode;
					if (step < 3) {
						this.chooseNotionlist[step] = data.children[0].value;
						this.chooseNotionTextlist[step] = data.children[0].label;
						this.notionExted[step] = data.children[0].relatedCode;
						if (step == 1) {
							this.notionlist2 = [];
							this.notionCode = data.children[0].children[0].relatedCode;
							this.chooseNotionlist[step + 1] = data.children[0].children[0].value;
							this.chooseNotionlist[step + 2] = 0;
							this.notionExted[step + 1] = data.children[0].children[0].relatedCode;
							this.notionExted[step + 2] = 0;
							this.chooseNotionTextlist[step + 1] = data.children[0].children[0].label;
							this.chooseNotionTextlist[step + 2] = 0;
							this.notionlist2 = data.children[0].children;
							this.notionlist3 = data.children[0].children[0].children;
						} else if (step == 2) {
							this.notionCode = data.children[0].relatedCode;
							this.notionlist3 = data.children[0].children;
						}
					}
				}
				this.notiontext = data.label;
			}

			if (step == 1 && data.children != null) {
				this.notionlist1 = data.children.filter(list => {
					return list.label != '环保';
				});
				if (this.computedNotionNum) {
					if (data.value != 'DEF') {
						this.notionlist2 = [];
					}
					this.notionlist3 = [];
				}
				this.notionlist4 = [];
			} else if (step == 2) {
				this.notionlist2 = data.children;
				if (this.computedNotionNum) {
					this.notionlist3 = [];
				}
				this.notionlist4 = [];
			} else if (step == 3) {
				this.notionlist3 = data.children;
				this.notionlist4 = [];
			} else if (step == 4) {
				this.notionlist4 = data.children || [];
				this.notionlist5 = [];
			} else if (step == 5) {
				this.notionlist5 = data.children;
			}

			this.closeSearchBar();
			console.log('传给父组件后最后的notioncode', this.chooseNotionlist, this.notionCode, step, this.notiontext);
			this.$emit('chooseNotion', this.chooseNotionlist, this.notionCode, step, this.notiontext);
		},

		setnotionNumlist(citynotionlist) {
			console.log('citynotionlist后台传回来的数量', citynotionlist, this.notionStep)
			if (!this.computedNotionNum || (this.notionStep > 4 && !this.isShowSecondLevelTotal)) {
				return;
			}
			var zancunNlist = [], citynotionlist1 = [];
			if (this.notionStep == 1) {
				if (this.isIntegration && !this.isShowSecondLevelTotal) {
					zancunNlist = this.notionlist2;
				} else {
					zancunNlist = this.notionlist1;
				}
			} else if (this.notionStep == 2) {
				zancunNlist = this.notionlist2;
			} else if (this.notionStep == 3) {
				zancunNlist = this.notionlist3;
			}
			console.log(zancunNlist, this.notionlist1, this.notionlist2, this.notionlist3, this.notionlist4)
			for (var i = 0; i < citynotionlist.length; i++) {
				for (var d = 0; d < zancunNlist.length; d++) {
					if (citynotionlist[i].notionCode == zancunNlist[d].value) {
						citynotionlist[i].children = zancunNlist[d].children;
						citynotionlist[i].label = zancunNlist[d].label;
						citynotionlist[i].value = zancunNlist[d].value;
						citynotionlist1.push(citynotionlist[i]);
						break;
					}
				}
			}
			if (this.notionStep == 1) {
				if (this.isIntegration && !this.isShowSecondLevelTotal) {
					this.notionlist2 = citynotionlist1;
				} else {
					this.notionlist1 = citynotionlist1;
				}
			} else if (this.notionStep == 2) {
				if (this.isIntegration && !this.isShowSecondLevelTotal) {
					this.notionlist2 = citynotionlist1;
					console.log('citynotionlist2', citynotionlist1)
				} else {
					this.notionlist2 = citynotionlist1;
				}
			} else if (this.notionStep == 3) {
				console.log('第三部');
				this.notionlist3 = citynotionlist1;
			}
		},

		formatSearchTitle(title) {
			return title.replace(this.searchWord, '<span class="red-font-1">' + this.searchWord + '</span>');
		},

		clearNotionResult() {
			console.log('清空概念');
			this.chooseNotionlist = this.isShowOneLevelTotal ? [0, 0, 0, 0, 0] : ['A', 0, 0, 0, 0, 0];
			this.notionCode = this.isShowOneLevelTotal ? 0 : 'A';
			this.notionlist1 = this.isShowOneLevelTotal ? [] : this.notionlist[0].children;
			this.notionlist2 = [];
			this.notionlist3 = [];
			this.notionlist4 = [];
			this.notionlist5 = [];
			// 可选：清空后回到搜索模式
			// this.isSearchMode = true;
		},
		// 修改：关闭搜索栏时，如果没有选中任何内容，保持搜索模式
		closeSearchBar() {
			this.showSearch = false;
			this.showSearchResult = false;
			this.searchWord = '';
			this.searchList = [];
		},
	}
}
</script>

<style lang="scss" scoped>
.sider-left {
	float: left;
	font-size: 14px;
	text-align: left;
	width: 380px;
	color: #000;
}

.area-bar {
	padding: 0 10px;
	position: relative;

	.count {
		margin: 0 10px;
	}

	.search-icon {
		float: right;
		margin-top: 7px;
		margin-right: 6px;
		font-size: 18px;

		&:hover {
			color: #39f;
		}
	}

	.el-icon-close {
		font-size: 18px;
	}

	.el-input__icon.el-icon-search {
		width: 18px;
		color: #5E83CC;
	}

	.search-bar {
		position: absolute;
		left: 0;
		top: 0;
		width: 98%;
		height: 100%;

		.search-text {
			margin: 5px 4px;
			width: 300px;
		}

		.search-btn {
			width: 60px;
			color: #5E83CC;

		}
	}
}

.view-bar {
	position: absolute;
	left: 4px;
	top: 44px;
	width: 300px;
	height: auto;
	z-index: 10;
	background: #fff;

	.box-card {
		.header {
			padding: 15px 20px;
		}

		.cont {
			padding: 5px 0;
			border-top: 1px solid #eee;
			max-height: 300px;
			overflow-y: auto;

			.item {
				cursor: default;
				padding: 10px 20px;
				overflow: hidden;
				cursor: pointer;

				&:hover {
					background: #eee;
				}
			}

			.code-f {
				float: left;
				width: 80px;
			}

			.title {
				width: 100%;
				height: auto;
				font-size: 14px;
				color: rgba(9, 22, 49, 0.842);
			}

			.addr {
				font-size: 12px;
				color: #999;
				margin-top: 4px;
			}
		}

		.title {
			font-size: 16px;
			font-weight: bold;
			color: rgba(9, 22, 49, 0.842);
		}
	}

	.pagination {
		padding: 10px 0;
	}
}
</style>